<template>
  <div class="source-place-input">
    <!-- Search box -->
    <a-input
      v-model:value="searchValue"
      :disabled="disabled"
      :placeholder="placeHolderText"
      style="margin-bottom: 8px;"
      @focus="dropdownVisible = true, selectedType = placeTypeSelected"
      @blur="handleBlur"
      @input="filterList"
      @update:value="handleChangeValue"
      autocomplete="off"
    />

    <!-- Type buttons inside the dropdown -->
    <transition name="slide-fade">
      <div
        v-if="dropdownVisible"
        class="dropdown-panel"
      >
        <a-space style="margin-bottom: 8px; flex-wrap: wrap; width: 100%;">
          <a-button
            v-if="matchClient"
            type="primary"
            :ghost="selectedType !== 1"
            @mousedown.prevent="setType(1)"
            size="small"
          >
            ที่อยู่ของบริษัท
          </a-button>
          <a-button
            type="primary"
            :ghost="selectedType !== 3"
            @mousedown.prevent="setType(3)"
            size="small"
          >
            ที่อยู่อื่นๆ
          </a-button>
          <a-button
            type="primary"
            :ghost="selectedType !== 'google'"
            @mousedown.prevent="setType('google')"
            size="small"
          >
            Google map
          </a-button>
        </a-space>

        <!-- Workplace list -->
        <div v-if="selectedType !== 'google'">
          <a-list
            :data-source="filteredWorkplaces"
            bordered
            size="small"
            class="dropdown-list"
          >
            <template #renderItem="{ item }">
              <a-list-item
                style="cursor:pointer"
                @mousedown.prevent="selectWorkplace(item)"
              >
                <span>{{ item.name }}</span>
                <span style="float:right; color:#888;">
                  {{ clients.find(c => c.id === item.client_id)?.fullname }}
                </span>
              </a-list-item>
            </template>
          </a-list>
        </div>

        <!-- Google map autocomplete -->
        <div v-else>
          <input
            ref="googleInput"
            type="text"
            class="form-control"
            placeholder="ค้นหาบน Google Map"
            @focus="initMap('googleInput')"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ClientService from '../api/ClientService.'; // <- check the "." at the end, may need to fix
import WorkPlaceService from '../api/WorkPlaceService';
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  name: 'SourcePlaceInput',
  components: { VueGoogleAutocomplete },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeHolderText: {
      type: String,
      default: ''
    },
    clientId : {
      type: Number,
      default: 0
    },
    disabled : {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedType: null,
      workplaces: [],
      dropdownVisible: false,
      clients: [],
      searchValue: '',
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        this.searchValue = newVal || '';
      }
    }
  },
  computed: {
    filteredWorkplaces() {
      //let typeIds = this.selectedType === 1 ? [1, 2] : [3];
      let filterValue = this.searchValue || '';
      if(filterValue === null){
        filterValue = '';
      }
      return this.workplaces
        .filter(w =>
          w?.name?.toLowerCase()?.includes(filterValue?.toLowerCase())
        ).filter(w => {
          if (this.selectedType === 1) {
            return w.client_id === this.clientId;
          }else{
            return w.client_id !== this.clientId;
          }
        });
    },
    matchClient() {
      return this.workplaces.some(item => item.client_id == this.clientId);
    },
    placeTypeSelected(){
      if(this.modelValue){
        return this.workplaces.find((item)=>item.name == this.modelValue)?.client_id == this.clientId 
                            ? 1 
                            : this.workplaces.find((item)=>item.name == this.modelValue) == null 
                            ? 'google'
                            : 3;
      }else{
        return this.matchClient ? 1 : 'google'
      }
    }
  },
  methods: {
    setType(type) {
      this.selectedType = type;
      this.searchValue = '';
      // this.$emit('change', null); // optional, depends on your use case
    },
    filterList() {
      // Just triggers computed
    },
    handleChangeValue(newVal) {      
      this.$emit('update:modelValue', null);
    },
    selectWorkplace(item) {
      this.$emit('placeSelected', item);
      this.searchValue = item.name;
      this.$emit('update:modelValue', item.name);
      this.dropdownVisible = false;
    },
    initMap(refName) {
      if (window.google && window.google.maps) {
        const input = this.$refs[refName];
        if (!input) return console.error("Input not found");

        const options = {
          types: ["establishment"],
          componentRestrictions: { country: "th" }
        };

        const googleMap = new google.maps.places.Autocomplete(input, options);

        googleMap.addListener("place_changed", () => {
          const place = googleMap.getPlace();
          if (place && place.name) {
            this.$emit("placeSelected", {
              name: place.name,
              address: place.formatted_address,
              location: place.geometry?.location?.toJSON?.()
            });
            this.searchValue = place.name;
            this.dropdownVisible = false;
          }
        });
      }
    },
    handleBlur() {
      // Delay so click event on list items still registers
      setTimeout(() => {
        const dropdown = this.$el.querySelector(".dropdown-panel");
        if (!dropdown?.contains(document.activeElement)) {
          this.dropdownVisible = false;
        }
      }, 200);
    }
  },
  async mounted() {
    this.workplaces = await WorkPlaceService.getAllByCompany();
    this.clients = await ClientService.getClientByCompany();
  },
};
</script>

<style scoped>
  .source-place-input {
    position: relative;
    width: 100%;
  }

  .dropdown-panel {
    position: absolute;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    width: 100%;
    z-index: 1000;
    padding: 8px;
  }

  .dropdown-list {
    max-height: 250px;
    overflow-y: auto;
  }

  /* Transition for dropdown */
  .slide-fade-enter-active,
  .slide-fade-leave-active {
    transition: all 0.2s ease;
  }
  .slide-fade-enter-from,
  .slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
  }
  .slide-fade-enter-to,
  .slide-fade-leave-from {
    opacity: 1;
    transform: translateY(0);
  }
</style>
